import React from 'react'
import { Tooltip } from '@mui/material'

function PageHeader ({
  title = '',
  subtitle = '',
  tooltip = '',
  total = 0,
  entriesLabel = 'Entries',
  children,
  containerClass = '',
  leftClass = '',
  rightClass = ''
}) {
  return (
    <div
      className={`flex justify-between flex-col lg:flex-row gap-4 mb-3  ${containerClass}`}
    >
      <div className={leftClass}>
        <Tooltip placement='right' title={tooltip}>
          <span className='font-semibold text-black/70 text-lg'>
            {title}
            {subtitle && (
              <span className='italic text-lg ml-1'>
                ({total}{' '}
                <span className='text-xs font-bold italic'>{entriesLabel}</span>
                )
              </span>
            )}
          </span>
        </Tooltip>
      </div>
      <div className={`flex gap-3 flex-col md:flex-row ${rightClass}`}>
        {children}
      </div>
    </div>
  )
}

export default PageHeader
